import { defineStore } from "pinia";
import { useCurrentUserStore } from "@stores/currentUser";
import { useAccountsStore } from "@stores/accounts";
import { useUsersStore } from "@stores/users";
import { useSurveyStore } from "@stores/survey/survey";
import { useSurveyProfilesStore } from "@stores/survey/surveyProfiles";
import { useProfileListStore } from "@stores/survey/profiles/profileList";
import { useDefaultMessagesStore } from "@stores/survey/defaultMessages";
import { useSurveyLocalesStore } from "@stores/survey/surveyLocales";
import { useConstantsStore } from "@stores/constants";
import { useCurrentCardStore } from "@stores/survey/currentCard/currentCard";
import { useSurveySectionsStore } from "@stores/survey/surveySections";
import { useSurveyCardsStore } from "@stores/survey/surveyCards";
import { useSurveyTargetsStore } from "@stores/survey/surveyTargets";
import { useSurveyErrorsStore } from "@stores/survey/surveyErrors";
import { useAppearancesStore } from "@stores/appearanceBubbles";
import { useBidderTargetsStore } from "@stores/bidderTargets";
import { useMCampaignStore } from "@stores/mCampaign";
import { useMCampaignTargetsStore } from "@stores/mCampaignTargets";
import { useCampaignTargetsStore } from "@stores/campaignTargets";
import { useMCampaignQuotasStore } from "@stores/mCampaignQuotas";
// import { useMCampaignActionsStore } from "@stores/mCampaignActions"; //FIXME !
import { useMAudiencesStore } from "@stores/mAudiences";
import { useMAudienceStore } from "@stores/mAudience/mAudience";
import { useMCreativesStore } from "@stores/mCreatives";
import { useMCreativeStore } from "@stores/mCreative";
import { useMMediumUploadsStore } from "@stores/mMediumUploads";
import { useMTemplatesStore } from "@stores/mTemplates";
import { useMMediaStore } from "@stores/mMedia";
import { useLocalesStore } from "@stores/mLocales";
import { useLocationsStore } from "@stores/mAudience/locations";
import { useEstimateStore } from "@stores/mAudience/estimate";
import { useMGroupsStore } from "@stores/mGroups";
import { useMGroupStore } from "@stores/mGroup";
import { useTaskProgressesStore } from "@stores/taskProgresses";
import { useSurveyQuestionsStore } from "@stores/surveyQuestions";
import { useCCampaignsStore } from "@stores/cCampaigns";
import { useCAdsetsStore } from "@stores/cAdsets";
import { useBudgetStore } from "@stores/budget";
import { useChatPagesStore } from "@stores/chatPages";
import { useAdsPagesStore } from "@stores/adsPages";
import { useAdAccountsStore } from "@stores/adAccounts";
import { useAiInsightConversationsStore } from "@stores/survey/assistant/aiInsightConversations";
import { useAiInsightConversationMessagesStore } from "@stores/survey/assistant/aiInsightConversationMessages";

// Reports
import { useQuestionListStore } from "@stores/survey/reports/questionList";
import { useSearchGroupListStore } from "@stores/survey/reports/searchGroupList";
import { useTargetListStore } from "@stores/survey/reports/targetList";

export const useAppInitStore = defineStore("appInit", () => {
  const loadStores = () => {
    useCurrentUserStore();
    useAccountsStore();
    useUsersStore();
    useSurveyStore();
    useSurveyProfilesStore();
    useProfileListStore();
    useDefaultMessagesStore();
    useSurveyLocalesStore();
    useConstantsStore();
    useCurrentCardStore();
    useSurveySectionsStore();
    useSurveyCardsStore();
    useSurveyTargetsStore();
    useSurveyErrorsStore();
    useAppearancesStore();
    useBidderTargetsStore();
    useMCampaignStore();
    useMCampaignTargetsStore();
    useCampaignTargetsStore();
    useMCampaignQuotasStore();
    // useMCampaignActionsStore(); //FIXME !
    useMAudiencesStore();
    useMAudienceStore();
    useMCreativesStore();
    useMCreativeStore();
    useMMediumUploadsStore();
    useMTemplatesStore();
    useMMediaStore();
    useLocalesStore();
    useLocationsStore();
    useEstimateStore();
    useMGroupsStore();
    useMGroupStore();
    useTaskProgressesStore();
    useSurveyQuestionsStore();
    useCCampaignsStore();
    useCAdsetsStore();
    useBudgetStore();
    useChatPagesStore();
    useAdsPagesStore();
    useAdAccountsStore();
    useMMediumUploadsStore();
    useMTemplatesStore();
    useMMediaStore();
    useMAudiencesStore();
    useAiInsightConversationsStore();
    useAiInsightConversationMessagesStore();

    // Reports
    useQuestionListStore();
    useSearchGroupListStore();
    useTargetListStore();
  };

  return {
    loadStores,
  };
});
